<template>
  <Vue100vh>
    <div class="home">
      <div class="clouds"></div>
      <div class="game-wrap">
        <div class="menuset" id="setup" >
          <exit-game ></exit-game>
          <button id="mute" class="muteSound" @click="muteSound()" :class="{'mute': soundOff}" v-if="setupGame.mute"></button>
        </div>
        <game-start v-if="setupGame.gameType == 0"></game-start>
        <game-hangman v-if="setupGame.gameType == 1"></game-hangman>
        <game-memory v-if="setupGame.gameType == 2"></game-memory>
        <game-shop v-if="setupGame.gameType == 3"></game-shop>
      </div>
    </div>
  </Vue100vh>

</template>
<script>
import {mapActions, mapGetters, mapMutations,} from 'vuex';
import GameStart from '@/templates/GameStarter/index';
import GameHangman from '@/templates/GameHangman/index.vue';
import GameMemory from "@/templates/GameMemory/index.vue";
import GameShop from "@/templates/GameShop/index";
import ExitGame from "@/components/exitGame";
import Vue100vh from 'vue-div-100vh'
export default {
  name: 'Home',
  data(){
    return{
      soundOff: false,
    }
  },
  components: {
    GameStart,
    ExitGame,
    Vue100vh,
    GameHangman,
    GameMemory,
    GameShop,
  },
  computed: {
    ...mapGetters(['setupGame','hangmanGame']),
  },
  methods: {
    ...mapActions([ 'startGame']),
    ...mapMutations(['SET_ACTIVE_VIEW','SET_ACTIVE_GAME']),
    gotoGame(paylod){
      this.SET_ACTIVE_GAME(paylod);
      this.SET_ACTIVE_VIEW(1);
    },
    muteSound(){
      this.soundOff = !this.soundOff;
      Howler.mute(this.soundOff)
    },
  },
 
 created() {
   let virtualPagePath = window.location.pathname;
   let virtualPagePathSearch = window.location.search;
   this.$gtm.push({
     event: 'virtualPageView',
     virtualPagePath: virtualPagePath + virtualPagePathSearch,
   })
 },
}
</script>
<style lang="scss">

.helper{
  position: fixed;
  bottom: 0;
  right:0;
  z-index: 500;
  background: #000;
  font-size: 16px;
  color: #fff;
  padding: 30px;
  font-family: Arial;
}

</style>
